// import userqueries from "@/store/queries";
// import empty_timeslot_collection, { empty_exception } from "@/models/_2018/empty_timeslot_collection";
// import util from "@/util";
// import firebase from "@firebase/app";
// import moment from '@/moment-gp';
// import db from "@/generic_api/firebase/db";

// function handleUpdateResponse() {
//   // console.log("success");
//   return true;
// }
//
// function legacy_user_doc() {
//   let uid = firebase.auth().currentUser.uid;
//   return db.collection("users/" + uid + "/private").doc("userdata");
// }
//
// // ------------------------------------------------------------------
//
// function timeslot_collection_add_to_user({ getters, rootGetters }, data ) {
//
//   /* Timeslots should be stored "timezone neutral" as UTC => nothing to do here
//      since collections and rules don't have a timezone */
//
//   /* Create emtpy timeslot collection */
//   let tscType = ( data && data.tscType ) ? data.tscType : 'TSC';
//   const timeslot_collection = empty_timeslot_collection( tscType );
//
//   // timeslot_collection.sortidx = ?
//   if ( tscType === 'BLOCKER' ) {
//     // TODO: This should be done while user is created
//   }
//   if ( tscType === 'GOOGLE' ) {
//     // TODO
//   }
//   if ( tscType === 'COMMITMENT' ) {
//     // TODO
//   }
//
//   /* Set sortidx to last value */
//   let timeslot_collection_list = getters.timeslot_collection_list;
//   timeslot_collection.sortidx = timeslot_collection_list.length + 1;
//
//   /* Add timeslot collection to user timeslot collection */
//   let new_id = util.get_new_uuid();
//   let payload = {};
//   Object.keys(timeslot_collection).forEach(idx => {
//     payload[`timeslotCollectionList.${new_id}.${idx}`] = timeslot_collection[idx];
//   });
//
//   console.log("timeslot_collection_add_to_user: submitting payload", payload);
//   return legacy_user_doc().update(payload).then(() => {
//     handleUpdateResponse();
//     return new_id;
//   });
//   // INFO: Update does not happen automatically
// }
//
// // ------------------------------------------------------------------
//
// function timeslot_collection_set(context, { timeslotCollectionId, prop, value }) {
//   if (timeslotCollectionId !== -1) {
//     let payload = {};
//     payload[`timeslotCollectionList.${timeslotCollectionId}.${prop}`] = value;
//     console.log("timeslot_collection_set: submitting payload", payload);
//     return legacy_user_doc().update(payload).then(handleUpdateResponse);
//   }
// }
//
// // ------------------------------------------------------------------
//
// function timeslot_collection_set_color(context, { timeslotCollectionId, color }) {
//   this.dispatch("timeslots/timeslot_collection_set", {
//     timeslotCollectionId: timeslotCollectionId,
//     prop: 'color',
//     value: color
//   });
// }
//
// // ------------------------------------------------------------------
//
// function timeslot_collection_set_name(context, { timeslotCollectionId, name }) {
//   this.dispatch("timeslots/timeslot_collection_set", {
//     timeslotCollectionId: timeslotCollectionId,
//     prop: 'name',
//     value: name
//   });
// }
// // ------------------------------------------------------------------
//
// function timeslot_collection_set_prioritized_effort_type(
//   context,
//   { timeslotCollectionId, prioritizedEffortType }
// ) {
//   const VALID_EFFORT_TYPES = [
//     'COMMITMENT_TEMPLATE',
//     'COMMITMENT',
//     'SEQUENCE_TYPE1',
//     'SEQUENCE_TYPE2',
//     'FIXED_TSC' ];
//
//   if ( VALID_EFFORT_TYPES.includes(prioritizedEffortType) ) {
//     this.dispatch("timeslots/timeslot_collection_set", {
//       timeslotCollectionId: timeslotCollectionId,
//       prop: 'prioritizedEffortType',
//       value: prioritizedEffortType
//     });
//   } else {
//     console.warn('Invalid effort type', prioritizedEffortType);
//   }
// }
//
// // ------------------------------------------------------------------
//
// function timeslot_collection_add_rule(context, {
//   timeslotCollectionId,
//   rule // = weekday_preference
// }) {
//   // TODO validate
//   /* Timeslots should be stored "timezone neutral" as UTC => nothing to do here
//      since rules don't have a timezone */
//
//   let new_id = util.get_new_uuid();
//   let payload = {};
//   Object.keys(rule).forEach(idx => {
//     payload[`timeslotCollectionList.${timeslotCollectionId}.weekday_preferences.${new_id}.${idx}`] = rule[idx];
//   });
//
//   console.log("timeslot_collection_add_rule: submitting payload", payload);
//   return legacy_user_doc().update(payload).then(handleUpdateResponse);
// }
//
// // ------------------------------------------------------------------
//
// function timeslot_collection_rem_rule(context, {
//   timeslotCollectionId,
//   ruleId
// }) {
//   let payload = {};
//   payload[`timeslotCollectionList.${timeslotCollectionId}.weekday_preferences.${ruleId}`] =
//     firebase.firestore.FieldValue.delete();
//
//   console.log("timeslot_collection_rem_exception: submitting payload", payload);
//   return legacy_user_doc().update(payload).then(handleUpdateResponse);
// }
//
// // ------------------------------------------------------------------
//
// function timeslot_collection_update_rule(context, {
//   timeslotCollectionId,
//   ruleId,
//   newRule
// }) {
//   // TODO Validate
//   /* Timeslots should be stored "timezone neutral" as UTC => nothing to do here
//      since rules don't have a timezone */
//
//   if ( 'valid_after' in newRule ) {
//     newRule.valid_after = firebase.firestore.Timestamp.fromDate( new Date(newRule.valid_after) );
//   }
//   if ( 'valid_before' in newRule ) {
//     newRule.valid_before = firebase.firestore.Timestamp.fromDate( new Date(newRule.valid_before) );
//   }
//
//   let payload = {};
//   Object.keys(newRule).forEach(idx => {
//     payload[`timeslotCollectionList.${timeslotCollectionId}.weekday_preferences.${ruleId}.${idx}`] = newRule[idx];
//   });
//
//   console.log("timeslot_collection_update_rule: submitting payload", payload);
//   return legacy_user_doc().update(payload).then(handleUpdateResponse);
// }
//
// // ------------------------------------------------------------------
//
// function timeslot_collection_add_exception({ getters }, {
//   timeslotCollectionId,
//   exception,
//   override_timezone
// }) {
//
//   // TODO: It would be better to store timeslots "timezone neutral" as UTC
//   //       ==> something to do here
//
//   let timeslot_collection_list = getters.timeslot_collection_list;
//   let timeslot_collection = timeslot_collection_list.find((tsc) => tsc.$id === timeslotCollectionId);
//   if ( !timeslot_collection ) {
//     throw new Error(`Timeslot collection with ID ${timeslotCollectionId} not found`);
//   }
//   let tscType = timeslot_collection.type || 'TSC'; // Default -> TSC
//
//   let exceptionTemplate = empty_exception( tscType, exception.type );
//   if ( !exceptionTemplate ) {
//     throw new Error(`Combination <${tscType}> and <${exception.type}>" not allowed`);
//   }
//
//   let exceptionValidated = {};
//   Object.keys(exceptionTemplate).map((key) => {
//     exceptionValidated[key] = exception[key] || exceptionTemplate[key];
//   })
//
//   if ( override_timezone ) {
//     console.log('Converting timezone to', override_timezone);
//     exceptionValidated.from = moment.fromTimezoneNeutral( exceptionValidated.from )
//                                   .changeTimezoneButKeepTime( override_timezone );
//
//       // convert_timezoneNeutral_to_qualifiedMomentObj(
//         // moment( exceptionValidated.from ), timezone );
//
//     exceptionValidated.to = moment.fromTimezoneNeutral( exceptionValidated.to )
//                                   .changeTimezoneButKeepTime( override_timezone );
//
//       // convert_timezoneNeutral_to_qualifiedMomentObj(
//         // moment( exceptionValidated.to ), timezone );
//   } else {
//     // TODO: Convert to UTC here
//     exceptionValidated.from = new Date( exceptionValidated.from );
//     exceptionValidated.to = new Date( exceptionValidated.to );
//   }
//   if ( 'date' in exceptionValidated ) {
//     exceptionValidated.date = firebase.firestore.Timestamp.fromDate( new Date(exceptionValidated.date) );
//   }
//   if ( 'from' in exceptionValidated ) {
//     exceptionValidated.from = firebase.firestore.Timestamp.fromDate( exceptionValidated.from );
//   }
//   if ( 'to' in exceptionValidated ) {
//     exceptionValidated.to = firebase.firestore.Timestamp.fromDate( exceptionValidated.to );
//   }
//
//   let new_id = util.get_new_uuid();
//   let payload = {};
//   Object.keys(exceptionValidated).forEach(idx => {
//     payload[`timeslotCollectionList.${timeslotCollectionId}.exception_list.${new_id}.${idx}`] = exceptionValidated[idx];
//   });
//
//   console.log("timeslot_collection_add_exception: submitting payload", payload);
//   return legacy_user_doc().update(payload).then(handleUpdateResponse);
// }
//
// // ------------------------------------------------------------------
//
// function timeslot_collection_rem_exception(context, {
//   timeslotCollectionId,
//   exceptionId
// }) {
//   let payload = {};
//   payload[`timeslotCollectionList.${timeslotCollectionId}.exception_list.${exceptionId}`] =
//     firebase.firestore.FieldValue.delete();
//
//   console.log("timeslot_collection_rem_exception: submitting payload", payload);
//   return legacy_user_doc().update(payload).then(handleUpdateResponse);
// }
//
// // --------------------------------------------------------------------
//
// function timeslot_collection_update_exception({ getters }, {
//   timeslotCollectionId,
//   exceptionId,
//   newException
// }) {
//
//   // TODO: Validate
//   // TODO: It would be better to store timeslots "timezone neutral" as UTC
//   //       ==> something to do here
//
//   // TODO: see timeslot_collection_add_exception
//   if ( 'date' in newException ) {
//     newException.date = firebase.firestore.Timestamp.fromDate( new Date(newException.date) );
//   }
//   if ( 'from' in newException ) {
//     newException.from = firebase.firestore.Timestamp.fromDate( new Date(newException.from) );
//   }
//   if ( 'to' in newException ) {
//     newException.to = firebase.firestore.Timestamp.fromDate( new Date(newException.to) );
//   }
//
//   let payload = {};
//   Object.keys(newException).forEach(idx => {
//     payload[`timeslotCollectionList.${timeslotCollectionId}.exception_list.${exceptionId}.${idx}`] = newException[idx];
//   });
//
//   console.log("timeslot_collection_update_exception: submitting payload", payload);
//   return legacy_user_doc().update(payload).then(handleUpdateResponse);
// }
//
// // ------------------------------------------------------------------
//
// function timeslot_collection_delete(context, {
//   timeslotCollectionId,
//   delete_mode
// }) {
//
//   // TODO: DO NOT ALLOW TO DELTE BLOCKERs
//
//   let payload = {};
//   if (delete_mode === "soft") {
//     payload[`timeslotCollectionList.${timeslotCollectionId}.deleted`] = true;
//   }
//
//   if (delete_mode === "hard") {
//     payload[`timeslotCollectionList.${timeslotCollectionId}`] = firebase.firestore.FieldValue.delete();
//   }
//
//   console.log("timeslot_collection_delete: submitting payload", payload);
//   return legacy_user_doc().update(payload).then(handleUpdateResponse);
// }
//
// // ------------------------------------------------------------------
//
// function timeslot_collection_set_priorities(context, { priorities } ) {
//
//   let payload = {};
//   priorities.forEach(({ id, sortidx }) => {
//     payload[`timeslotCollectionList.${id}.sortidx`] = sortidx;
//   });
//
//   console.log("timeslot_collection_set_priorities: submitting payload", payload);
//   return legacy_user_doc().update(payload).then(handleUpdateResponse);
// }
//
// // ------------------------------------------------------------------
//
// function timeslot_collection_set_rule_priorities(context, {
//   timeslotCollectionId,
//   priorities
// }) {
//
//   if ( !timeslotCollectionId ) {
//     throw Error('Invalid timeslotCollectionId');
//   }
//
//   let payload = {};
//   priorities.forEach(({ id, sortidx }) => {
//     payload[`timeslotCollectionList.${timeslotCollectionId}.weekday_preferences.${id}.sortidx`] = sortidx;
//   });
//
//   console.log("timeslot_collection_set_rule_priorities: submitting payload", payload);
//   return legacy_user_doc().update(payload).then(handleUpdateResponse);
// }

// ------------------------------------------------------------------

export default {
  // timeslot_collection_add_to_user,
  // timeslot_collection_set,
  // timeslot_collection_add_rule,
  // timeslot_collection_rem_rule,
  // timeslot_collection_update_rule,
  // timeslot_collection_set_rule_priorities,
  // timeslot_collection_add_exception,
  // timeslot_collection_rem_exception,
  // timeslot_collection_update_exception,
  // timeslot_collection_set_color,
  // timeslot_collection_set_name,
  // timeslot_collection_set_prioritized_effort_type,
  // timeslot_collection_delete,
  // timeslot_collection_set_priorities
};
